
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.156 3.5a.656.656 0 01-.656.656h-7a.656.656 0 110-1.312h7a.656.656 0 01.656.656zM12.687.219H1.313a.656.656 0 100 1.312h11.374a.656.656 0 100-1.312zm-4.374 5.25H5.687a.656.656 0 100 1.312h2.625a.656.656 0 100-1.312z","fill":"currentColor"}})])
          )
        }
      }
    